import { ApiKey, Environment } from "../../ampli";
import { ObjectTypes } from "../../types";

export const AG_GRID_LICENCE =
  "Using_this_AG_Grid_Enterprise_key_( AG-045299 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( CDK Global, LLC )_is_granted_a_( Multiple Applications )_Developer_License_for_( 126 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 21 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 31 October 2024 )____[v2]_MTczMDMzMjgwMDAwMA==1cb7187692fbeb98105fb9141ee7c379";
export enum ReactEnvironments {
  Develop = "dev",
  DIT = "dit",
  Staging = "stage",
  Perf = "perf",
  Production = "prod",
  Local = "local",
}

export const OKTA_ISSUER: ObjectTypes = {
  [ReactEnvironments.Local]:
    "https://connectcdk-dit.oktapreview.com/oauth2/default",
  [ReactEnvironments.Develop]:
    "https://connectcdk-dit.oktapreview.com/oauth2/default",
  [ReactEnvironments.DIT]:
    "https://connectcdk-dit.oktapreview.com/oauth2/default",
  [ReactEnvironments.Staging]:
    "https://connectcdk-dit.oktapreview.com/oauth2/default",
  [ReactEnvironments.Perf]:
    "https://connectcdk-dev.oktapreview.com/oauth2/default", // referring dev, instead of perf as Okta Perf is not live
  [ReactEnvironments.Production]: "https://connectcdk.okta.com/oauth2/default",
};

export const OKTA_LOG_OFF: ObjectTypes = {
  [ReactEnvironments.Local]: "https://login-dit.connectcdk.com/sso/logoff",
  [ReactEnvironments.Develop]: "https://login-dit.connectcdk.com/sso/logoff",
  [ReactEnvironments.DIT]: "https://login-dit.connectcdk.com/sso/logoff",
  [ReactEnvironments.Staging]: "https://login-dit.connectcdk.com/sso/logoff",
  [ReactEnvironments.Perf]: "https://login-perf.connectcdk.com/sso/logoff",
  [ReactEnvironments.Production]: "https://login.connectcdk.com/sso/logoff",
};

export const OKTA_POST_LOGOUT_REDIRECT_URIS: ObjectTypes = {
  [ReactEnvironments.Local]: "http://localhost:3000/logout-success",
  [ReactEnvironments.Develop]:
    "https://app-cdcm-ui.app-dev.connectcdk.com/logout-success",
  [ReactEnvironments.DIT]:
    "https://app-cdcm-ui.app-dit.connectcdk.com/logout-success",
  [ReactEnvironments.Staging]:
    "https://app-cdcm-ui.app-stage.connectcdk.com/logout-success",
  [ReactEnvironments.Perf]:
    "https://app-cdcm-ui.app-perf.connectcdk.com/logout-success",
  [ReactEnvironments.Production]:
    "https://app-cdcm-ui.app.connectcdk.com/logout-success",
};

export const OKTA_AUTHORIZE_URIS: ObjectTypes = {
  [ReactEnvironments.Local]: "https://login-dit.connectcdk.com/login/authorize",
  [ReactEnvironments.Develop]:
    "https://login-dit.connectcdk.com/login/authorize",
  [ReactEnvironments.DIT]: "https://login-dit.connectcdk.com/login/authorize",
  [ReactEnvironments.Staging]:
    "https://login-dit.connectcdk.com/login/authorize",
  [ReactEnvironments.Perf]: "https://login-perf.connectcdk.com/login/authorize",
  [ReactEnvironments.Production]:
    "https://login.connectcdk.com/login/authorize",
};

export const OKTA_TOKEN_URL: ObjectTypes = {
  [ReactEnvironments.Local]:
    "https://cml-api-nginx.global-dit.connectcdk.com/token",
  [ReactEnvironments.Develop]:
    "https://cml-api-nginx.global-dit.connectcdk.com/token",
  [ReactEnvironments.DIT]:
    "https://cml-api-nginx.global-dit.connectcdk.com/token",
  [ReactEnvironments.Staging]:
    "https://cml-api-nginx.global-dit.connectcdk.com/token",
  [ReactEnvironments.Perf]:
    "https://nginx.nebula-perf.connectcdk.com/api/cs-common-login-api/v1/token",
  [ReactEnvironments.Production]:
    "https://cml-api-nginx.global.connectcdk.com/token",
};

export const OKTA_CLIENT_ID: ObjectTypes = {
  [ReactEnvironments.Local]: "0oa1dtasx7wPrAU0W0h8", // referring Okta DIT Client ID
  [ReactEnvironments.Develop]: "0oa1dtasx7wPrAU0W0h8", // referring Okta DIT Client ID
  [ReactEnvironments.DIT]: "0oa1dtasx7wPrAU0W0h8", // referring Okta DIT Client ID
  [ReactEnvironments.Staging]: "0oa1dtasx7wPrAU0W0h8", // referring Okta DIT Client ID
  [ReactEnvironments.Perf]: "0oa2gsrz0s4XG3NsB0h8", // referring Okta Dev Client ID, instead of perf as Okta Perf is not live
  [ReactEnvironments.Production]: "0oapq2uqzhiqg19d01t7", // referring Production Client ID
};

export const AMPLI_ENV_DEV: Environment = "development";
export const AMPLI_ENV_PROD: Environment = "production";

export const AMPLI_KEYS: ObjectTypes = {
  [ReactEnvironments.Develop]: ApiKey.development,
  [ReactEnvironments.Production]: ApiKey.production,
};

export const emptyStateText =
  "There's is no data to display yet.\n Select a store, application and setup to get started.";
